import { render, staticRenderFns } from "./TemplateFontAddForm.vue?vue&type=template&id=7dfca2ae"
import script from "./TemplateFontAddForm.vue?vue&type=script&lang=js"
export * from "./TemplateFontAddForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports